import { API_BASE_URL, getAuthHeaders, handleResponse } from './api';
import type { APIResponse, ModuleProgress, DashboardSummary, ModuleId } from '../types';

class ProgressService {
  async getAllProgress(): Promise<APIResponse<ModuleProgress[]>> {
    const response = await fetch(`${API_BASE_URL}/progress`, {
      method: 'GET',
      headers: getAuthHeaders(),
    });
    const data = await handleResponse(response);
    return { success: true, data: data.progress || [], message: 'Progress retrieved' };
  }

  async getModuleProgress(moduleId: ModuleId): Promise<APIResponse<ModuleProgress>> {
    const response = await fetch(`${API_BASE_URL}/progress/${moduleId}`, {
      method: 'GET',
      headers: getAuthHeaders(),
    });
    const data = await handleResponse(response);
    return { success: true, data: data.progress, message: 'Module progress retrieved' };
  }

  async saveStepData(
    moduleId: ModuleId,
    stepId: string,
    stepData: unknown,
    currentStepIndex: number,
    totalSteps: number
  ): Promise<APIResponse<ModuleProgress>> {
    const response = await fetch(`${API_BASE_URL}/progress/${moduleId}/steps/${stepId}`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ stepData, currentStepIndex, totalSteps }),
    });
    const data = await handleResponse(response);
    return { success: true, data: data.progress, message: 'Step data saved' };
  }

  async updateCurrentStep(
    moduleId: ModuleId,
    currentStepIndex: number,
    currentStepId: string,
    totalSteps: number
  ): Promise<APIResponse<ModuleProgress>> {
    const response = await fetch(`${API_BASE_URL}/progress/${moduleId}/current-step`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ currentStepIndex, currentStepId, totalSteps }),
    });
    const data = await handleResponse(response);
    return { success: true, data: data.progress, message: 'Current step updated' };
  }

  async completeStep(moduleId: ModuleId, stepId: string): Promise<APIResponse<ModuleProgress>> {
    const response = await fetch(`${API_BASE_URL}/progress/${moduleId}/complete-step/${stepId}`, {
      method: 'POST',
      headers: getAuthHeaders(),
    });
    const data = await handleResponse(response);
    return { success: true, data: data.progress, message: 'Step completed' };
  }

  async getDashboardSummary(): Promise<APIResponse<DashboardSummary>> {
    const response = await fetch(`${API_BASE_URL}/progress/dashboard-summary`, {
      method: 'GET',
      headers: getAuthHeaders(),
    });
    const data = await handleResponse(response);
    return { success: true, data: data.summary, message: 'Dashboard summary retrieved' };
  }
}

export const progressService = new ProgressService();
export default progressService;
